import { Modifier } from '@popperjs/core/lib/popper-lite';
import { isMobile } from '../../utils';

export const viewModalOnMobile: Modifier<'viewModalOnMobile', {}> = {
  name: 'viewModalOnMobile',
  enabled: true,
  phase: 'beforeWrite',
  fn({ state }) {
    if (isMobile()) {
      state.styles.popper = {
        left: '0',
        right: '0',
        top: '0',
        bottom: '0',
        transform: 'none'
      };
    }
  }
};
